module.exports = __webpack_public_path__ + "static/media/tiktok copy.03cc99fc.png";